import React, { ReactNode } from 'react';
import { Card } from 'snacks-design-system';

export enum PIECardModes {
  REGULAR = 'regular',
  OUTLINE = 'outline',
}

export enum PIECardLayouts {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum PIECardPadding {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum PIECardAlign {
  START = 'start',
  CENTER = 'center',
  END = 'end',
}

export enum PIECardPanelModes {
  SUBTLE = 'subtle',
  INFO = 'info',
  WARNING = 'warning',
}

export enum PIECardDisabledModes {
  DEFAULT = 'default',
  SUBTLE = 'subtle',
  CUSTOM = 'custom',
}

export enum PIECardBorderRadius {
  LARGE = 'large',
}

export interface IPIECardAria {
  label?: string;
  labelledby?: string;
  describedby?: string;
  roledescription?: string;
  hint?: string;
  modpaneltoggle: Boolean;
  modstaticgroup: Boolean;
}

interface IPIECard {
  className?: string;
  children: ReactNode;
  panel?: ReactNode;
  backgroundImage?: ReactNode;
  mode?: PIECardModes;
  layout?: PIECardLayouts;
  padding?: PIECardPadding;
  align?: PIECardAlign;
  role?: string;
  panelMode?: PIECardPanelModes;
  linkProps?: Object;
  iconButtonProps?: Object;
  isDisabled?: Boolean;
  disabledMode?: PIECardDisabledModes;
  showPanel?: Boolean;
  modPanelClickable?: Boolean;
  modImageInSet?: Boolean;
  borderRadius?: PIECardBorderRadius | Boolean;
  modBackground?: Boolean;
  modElevation?: Boolean;
  aria?: IPIECardAria;
  onClick?: () => void;
  onActionClick?: () => void;
  qaSelector?: String;
}

const PIECard = (props: IPIECard) => {
  return <Card {...props} />;
};

export default PIECard;
